import apiClient from './client';
import { endpoints } from './endpoints';

interface StepPayload {
  imageUrl?: string;
  videoUrl?: string;
  tutorialId?: string;
  [key: string]: unknown;
}

export const stepService = {
  async list(tutorialId: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.steps.list(tutorialId));
    return response.data;
  },
  normalizeStepPayload(data: StepPayload): Record<string, unknown> {
    const payload = { ...data };
    if (payload.imageUrl !== undefined) (payload as Record<string, unknown>).image_url = payload.imageUrl;
    if (payload.videoUrl !== undefined) (payload as Record<string, unknown>).video_url = payload.videoUrl;
    return payload as Record<string, unknown>;
  },
  async create(tutorialId: string, data: StepPayload): Promise<unknown> {
    const targetId = (data.tutorialId as string) || tutorialId;
    const { tutorialId: _, ...rest } = data;
    const payload = stepService.normalizeStepPayload(rest);
    const response = await apiClient.post(endpoints.steps.create(targetId), payload);
    return response.data;
  },
  async update(tutorialId: string, stepId: string, data: StepPayload): Promise<unknown> {
    const payload = stepService.normalizeStepPayload(data);
    const response = await apiClient.put(endpoints.steps.update(tutorialId, stepId), payload);
    return response.data;
  },
  async delete(tutorialId: string, stepId: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.steps.delete(tutorialId, stepId));
    return response.data;
  },
  async reorder(tutorialId: string, stepIds: string[]): Promise<unknown> {
    const response = await apiClient.post(endpoints.steps.reorder(tutorialId), { stepIds });
    return response.data;
  },
};

export default stepService;
